// Service to fetch transit routes from Google Maps Directions API
import debug from "./debug";

// User-friendly messages for different DirectionsStatus values
export const getDirectionsErrorMessage = (
  status: google.maps.DirectionsStatus,
): string => {
  switch (status) {
    case google.maps.DirectionsStatus.ZERO_RESULTS:
      return "No transit routes found for this trip. Try a different time or check if transit service is available in this area.";
    case google.maps.DirectionsStatus.NOT_FOUND:
      return "One of the locations could not be found. Please check your addresses and try again.";
    case google.maps.DirectionsStatus.OVER_QUERY_LIMIT:
      return "Too many requests. Please wait a moment and try again.";
    case google.maps.DirectionsStatus.REQUEST_DENIED:
      return "Route request was denied. Please contact support if this persists.";
    case google.maps.DirectionsStatus.INVALID_REQUEST:
      return "Invalid route request. Please check your locations and try again.";
    default:
      return "Unable to find routes. Please try again later.";
  }
};

export const fetchDirections = async (
  request: google.maps.DirectionsRequest,
): Promise<{
  result: google.maps.DirectionsResult | null;
  status: google.maps.DirectionsStatus;
}> => {
  const { origin, destination, transitOptions } = request;

  if (!origin || !destination || !transitOptions?.departureTime) {
    throw new Error("Missing required fields");
  }

  const directionsService = new google.maps.DirectionsService();

  return new Promise((resolve) => {
    directionsService.route(request, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK && result) {
        debug.log(" Found", result.routes?.length || 0, "routes");
        resolve({ result, status });
      } else {
        // Log as info, not error - these are expected conditions
        debug.log(" No routes found -", status);
        resolve({ result: null, status });
      }
    });
  });
};
